export var surface_core__ask__entitites__askentities__MoveOut;
(function (surface_core__ask__entitites__askentities__MoveOut) {
    let type;
    (function (type) {
        type["MOVE_OUT"] = "MoveOut";
    })(type = surface_core__ask__entitites__askentities__MoveOut.type || (surface_core__ask__entitites__askentities__MoveOut.type = {}));
})(surface_core__ask__entitites__askentities__MoveOut || (surface_core__ask__entitites__askentities__MoveOut = {}));
